module.exports = __webpack_public_path__ + "static/media/plus-alt.afc0e72a.svg";